import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Loading from "@component/UI/Loading";

export default () => {
    const { site, iam } = useContext(AppContext);
    const [cfg, setCfg] = useState(null);

    const [memos, setMemos] = useState([]);
    const [options, setOptions] = useState(null);
    const [data, setData] = useState({});
    const [program, setProgram] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const loadConfig = () => {
        _API.get({ path: "/site/registration/config" })
            .then((res) => {
                const { cfg, options, memos, amounts, reg } = res.data;
                if (!reg) {
                    navigate("/registration/regist");
                }
                setCfg(cfg);
                setOptions(options);
                setMemos(memos);
                setData(reg);
                if (reg?.program && reg?.program?.length > 0) {
                    setProgram(reg?.program);
                }
            })
            .catch((e) => {
                _API.alert({ message: e.messages });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadConfig();
        }
    }, [site?.siteCode]);

    useEffect(() => {
        if (cfg) {
            if (cfg?.isUseEarly !== "Y" && cfg?.isUsePre !== "Y" && cfg?.isUseLate !== "Y") {
                swal("Pre-registration settings have not been completed.").then(() => {
                    navigate("/");
                });
                return;
            }

            if (data?.payStatus === "Y") {
                swal("Please directly contact the secretariat (" + site["emailRegistration"] + ") to modify your registration status.").then(() => {
                    navigate("/");
                });
                return;
            }

            let expire = 0;
            //early
            if (cfg?.isUseEarly === "Y" && moment() >= moment(cfg.earlyStartDate) && moment() < moment(cfg.earlyEndDate)) {
                expire++;
                if (!data?.amountType) setData({ ...data, amountType: "EARLY" });
            }

            //regular
            if (expire == 0 && cfg?.isUsePre === "Y" && moment() >= moment(cfg.preStartDate) && moment() < moment(cfg.preEndDate)) {
                expire++;
                if (!data?.amountType) setData({ ...data, amountType: "PRE" });
            }

            //onsite
            if (expire == 0 && cfg?.isUseLate === "Y" && moment() >= moment(cfg.lateStartDate) && moment() < moment(cfg.lateEndDate)) {
                expire++;
                if (!data?.amountType) setData({ ...data, amountType: "LATE" });
            }

            if (expire <= 0) {
                swal("This is not the registration period.").then(() => {
                    navigate("/");
                });
                return;
            }

            setIsLoading(false);
        }
    }, [cfg, data]);

    const getMemo = (type, field) => {
        let memo = memos?.find((m) => m.type === type);

        if (!memo?.[field]) {
            return "";
        }
        if (field === "title") {
            return memo?.[field];
        } else {
            return <p dangerouslySetInnerHTML={{ __html: memo?.[field] }}></p>;
        }
    };

    const onDataChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const getPrice = (item) => {
        let price = 0;

        if (data?.amountType === "EARLY") {
            price = iam?.country === "KR" ? item.earlyWonAmount : item.earlyUsdAmount;
        }
        if (data?.amountType === "PRE") {
            price = iam?.country === "KR" ? item.preWonAmount : item.preUsdAmount;
        }
        if (data?.amountType === "LATE") {
            price = iam?.country === "KR" ? item.lateWonAmount : item.lateUsdAmount;
        }

        return price || 0;
    };

    const onProgramClick = (e, item) => {
        let tmp = JSON.parse(JSON.stringify(program));
        const value = e.target.value;

        const original = tmp.find((t) => t.programIdx === item.idx);
        tmp = tmp.filter((t) => t.programIdx !== item.idx);

        tmp.push({
            ...original,
            amountType: data?.amountType,
            amount: value === "Y" ? getPrice(item) : 0,
            programIdx: item.idx,
            participantIdx: data?.idx,
            value,
            lang: iam?.country === "KR" ? "WON" : "USD",
        });

        setProgram(tmp);
    };

    const onNext = () => {
        if (options?.length > 0) {
            for (let i in options) {
                const o = options[i];

                if (o.limitRegistration && o.limitRegistration > o.programCount) {
                    if (!program.find((p) => p.programIdx === o.idx)) {
                        swal(`Please select program(${o.title}).`);
                        return;
                    }
                }
            }
        }

        _API.post({ path: "/site/registration/step2", data: { data, program, registrationIdx: cfg?.idx } })
            .then((res) => {
                if (res.error === 0) {
                    navigate("/registration/regist/step3");
                }
            })
            .catch((e) => {
                console.log(e);
                _API.alert({ message: e.message });
                // swal({ title: "알림", text: e.message }).then(() => {
                //     navigate("/registration/regist");
                // });
            });
    };

    const getProgramSum = () => {
        let totalPrice = 0;

        for (let i in program) {
            const p = program[i];
            totalPrice += p.amount;
        }

        return totalPrice;
    };

    const isProgramChecked = (item, value) => {
        if (program && program?.length > 0) {
            return program.find((p) => p.programIdx === item.idx && p.value === value);
        }

        return false;
    };

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });
        return;
    }

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {site?.naviRegistration && parse(site?.naviRegistration)}
                <div className="right">
                    <div className="contentsTop">
                        <h3>Online Registration</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Online Registration</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        {cfg?.isUseOptionProgram === "Y" && options && options?.length > 0 && (
                            <>
                                <h4 className="title">{getMemo("PROGRAM", "title") || "Social Programs & Excursion"}</h4>

                                {getMemo("PROGRAM", "content")}

                                <div className="boxTable">
                                    <table className="online_reg_step01">
                                        <thead>
                                            <tr>
                                                <th width="50%">Optional Program</th>
                                                <th colspan="2">Select</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {options?.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="tit">
                                                        {item.title}
                                                        {item?.description && <p className="sub_descript" dangerouslySetInnerHTML={{ __html: item?.description }}></p>}
                                                    </td>
                                                    <td width="25%">
                                                        {item.limitRegistration && item.limitRegistration <= item.programCount ? (
                                                            <p className="sub_descript">Closed</p>
                                                        ) : (
                                                            <>
                                                                <label>
                                                                    <input type="radio" name={item.name} value="Y" checked={isProgramChecked(item, "Y")} onClick={(e) => onProgramClick(e, item)} />
                                                                    &nbsp; Yes
                                                                </label>
                                                                &nbsp;&nbsp;
                                                                <label>
                                                                    <input type="radio" name={item.name} value="N" checked={isProgramChecked(item, "N")} onClick={(e) => onProgramClick(e, item)} />
                                                                    &nbsp; No
                                                                </label>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td width="25%">
                                                        {getPrice(item) !== 0 && iam?.country !== "KR" && `USD `}
                                                        {getPrice(item) ? _U.addComma(getPrice(item)) : "Free"}
                                                        {getPrice(item) !== 0 && iam?.country === "KR" && ` 원`}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td className="total">Sub Total</td>
                                                <td className="total" colspan="3">
                                                    {getProgramSum() !== 0 && iam?.country !== "KR" && `USD `}
                                                    {getProgramSum() ? _U.addComma(getProgramSum()) : "Free"}
                                                    {getProgramSum() !== 0 && iam?.country === "KR" && ` 원`}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                        {cfg?.isUseSpecialDietary === "Y" && (
                            <>
                                <br />
                                <br />
                                <h4 className="title">{getMemo("DIATARY", "title") || "Special Dietary Requests"}</h4>

                                {getMemo("DIATARY", "content")}

                                <div className="boxTable">
                                    <table className="online_reg_step01">
                                        <tr>
                                            <td className="tit" width="25%" style={{ verticalAlign: "middle" }}>
                                                Vegetarian
                                            </td>
                                            <td width="75%">
                                                <textarea placeholder="Please write down exact information" name="vegetarian" onChange={onDataChange} value={data?.vegetarian}></textarea>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit" width="25%" style={{ verticalAlign: "middle" }}>
                                                Allergic
                                            </td>
                                            <td width="75%">
                                                <textarea placeholder="Please write down exact information" name="allergic" onChange={onDataChange} value={data?.allergic}></textarea>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit" width="25%" style={{ verticalAlign: "middle" }}>
                                                Others
                                            </td>
                                            <td width="75%">
                                                <textarea placeholder="Please write down exact information" name="etc" onChange={onDataChange} value={data?.etc}></textarea>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </>
                        )}

                        <div className="btnArea1">
                            <button className="btn1 btnGray1 mr2" onClick={() => navigate("/registration/regist")}>
                                Back
                            </button>
                            <button className="btn1 btnBlue1" onClick={onNext}>
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
